import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function CircleHelpFillIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m0 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-10c-1.588 0-3.154.833-3.825 2.364l-.122.316a1 1 0 0 0 1.894.64l.056-.143C10.31 8.477 11.067 8 12 8c1.17 0 2 .785 2 2 0 .565-.21.96-.614 1.349-.456.438-1.083.8-1.903 1.296a1 1 0 1 0 1.034 1.71c.724-.437 1.597-.933 2.255-1.565C15.48 12.108 16 11.22 16 10c0-2.354-1.76-4-4-4" />
    </Icon>
  );
}

CircleHelpFillIcon.displayName = 'CircleHelpFillIcon';
